<template>
  <!-- 転記テンプレート設定タブ -->
  <div id="TranscriptionTemplateSetting">
    <div id="container-modal">
      <div class="template-select-area">
        <select class="template-select-box" v-model.number="displayOrder" size="6" @change="selectTextTemplate()">
          <option :value="newDisplayOrder">
            （新規）
          </option>
          <option v-for="selectTemplate in textTemplateList" :key="selectTemplate.displayOrder" :value="selectTemplate.displayOrder">
            <a v-if="selectTemplate.defaultFlag" :v-model="textTemplateDisplayInfo.defaultFlag">【既定】</a>{{ selectTemplate.templateName }}
          </option>
        </select>
        <fieldset class="buttonArea" :disabled="isButtonDisabled">
          <b-button class="is-primary" @click="copyTextTemplate()">コピー</b-button>
          <b-button class="is-primary" @click="deleteTextTemplate()">削除</b-button>
          <b-button v-if="!selectedTemplateInfo.defaultFlag" class="is-primary" @click="setDefaultDisplayTemplate(true)">既定に設定</b-button>
          <b-button v-if="selectedTemplateInfo.defaultFlag" class="is-primary" @click="setDefaultDisplayTemplate(false)">既定を解除</b-button>
          <b-button class="is-primary arrow-button" @click="upTextTemplate">↑</b-button>
          <b-button class="is-primary arrow-button" @click="downTextTemplate">↓</b-button>
        </fieldset>
      </div>
      <div class="template-edit-area">
        <div class="template-edit-content">
          <div class="templatename-block">
            <div class="left-area">
              <div class="templatename-label">テンプレート名</div>
              <input class="templatename-input" v-model="textTemplateDisplayInfo.templateName" :disabled="isTextAreaDisabled" maxlength="30"/>
            </div>
          </div>
          <div class="displayitem-block">
            <div class="left-area">
              <div class="displayitem-label">表示項目（置換用）</div>
              <select class="displayitem-select" v-model="itemName" :disabled="isTextAreaDisabled">
                <option v-for="selectItem in itemNameList" :key="selectItem.itemName" :value="selectItem.itemName">
                  {{ selectItem.itemName }}
                </option>
              </select>
            </div>
            <div class="right-area">
              <b-button class="is-primary" :disabled="isTextAreaDisabled" @click="insertTextTemplateBody(itemName)">挿入</b-button>
            </div>
          </div>
          <div class="content-block">
            <div class="left-area">
              <div class="content-label">本文</div>
              <div class="maxlength" v-if="textTemplateDisplayInfo.text">({{ textTemplateDisplayInfo.text.length }}文字／最大2000文字)</div>
            </div>
            <div class="right">
              <b-button class="is-primary" :disabled="isTextAreaDisabled" @click="saveTextTemplate()">保存</b-button>
            </div>
          </div>
        </div>
        <textarea class="body-text-area" v-model="textTemplateDisplayInfo.text" type="text" :disabled="isTextAreaDisabled" maxlength="2000"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import { shiftListDetail } from "@/components/mock/guest/patientdashboard/pDashboardUtil";

export default {
  name: "TranscriptionTemplateSetting",
  methods: {
    // 環境設定画面が取得した初期値を受け取る
    setTextTemplateInfo(transcriptionTemplateInfo) {
      this.textTemplateList = transcriptionTemplateInfo.textTemplateList;
      this.itemNameList = transcriptionTemplateInfo.itemNameList;
      this.itemName = this.itemNameList[0].itemName,
      this.templateLimitCount = transcriptionTemplateInfo.templateLimitCount;
    },
    // 選択されたテンプレート表示順からテンプレート情報を返す
    selectTextTemplate() {
      this.itemName = this.itemNameList[0].itemName,
      this.selectedTemplateInfo = {};
      if (this.displayOrder == 0) {
        // 新規が選択された場合のテンプレート情報
        this.textTemplateDisplayInfo = {
          id: "",
          templateName: "",
          text: "",
          defaultFlag: false,
          displayOrder: this.textTemplateList.length + 1
        };
      } else if (1 <= this.displayOrder) {
        this.selectedTemplateInfo = this.textTemplateList.find(selectData => selectData.displayOrder == this.displayOrder);
        // 直接編集をしないために画面に表示するテンプレート情報を複製
        this.textTemplateDisplayInfo = this.getCopy(this.selectedTemplateInfo);
      }
      this.changeControlActive();
    },
    // テンプレートボタン欄とテキスト欄の活性・非活性処理
    changeControlActive() {
      if (this.displayOrder == null) {
        // 未選択の場合、ボタンとテキストエリアを非活性
        this.isButtonDisabled = true;
        this.isTextAreaDisabled = true;
      } else if (this.displayOrder == 0) {
        // 新規の場合、ボタンを非活性、テキストエリアを活性
        this.isButtonDisabled = true;
        this.isTextAreaDisabled = false;
      } else {
        // 登録済みのテンプレートを選択中の場合、ボタンとテキストエリアを活性
        this.isButtonDisabled = false;
        this.isTextAreaDisabled = false;
      }
    },
    // コピーボタン処理
    copyTextTemplate() {
      this.textTemplateDisplayInfo = {
        id: "",
        templateName: this.selectedTemplateInfo.templateName + "（コピー）",
        text: this.selectedTemplateInfo.text,
        defaultFlag: this.selectedTemplateInfo.defaultFlag,
        displayOrder: this.textTemplateList.length + 1
      }
      this.isButtonDisabled = true;
      this.isTextAreaDisabled = false;
    },
    // 削除ボタン処理
    deleteTextTemplate() {
      let _this = this;
      this.$dialog.confirm({
        title: "　",
        message: "選択しているテンプレートを削除します。<br/>よろしいでしょうか？",
        confirmText:"OK",
        cancelText: "キャンセル",
        onConfirm: () => {
          if (!_this.textTemplateDisplayInfo.id) {
            // 新規の場合はデータベースに登録されていないため置換用転記テンプレート表示リストから削除するのみ
            _this.textTemplateList = _this.textTemplateList.filter(deleteTemplate => deleteTemplate.displayOrder != _this.textTemplateDisplayInfo.displayOrder);
          } else {
            // 削除対象のテンプレートを削除リストに格納
            _this.textTemplateDeleteList.push(_this.textTemplateList.find(deleteTemplate => deleteTemplate.displayOrder == _this.textTemplateDisplayInfo.displayOrder));
            // 置換用転記テンプレート表示リストから削除対象のテンプレートを削除
            _this.textTemplateList = _this.textTemplateList.filter(deleteTemplate => deleteTemplate.displayOrder != _this.textTemplateDisplayInfo.displayOrder);
          }
          // 表示順が削除対象より大きいテンプレートの表示順を-1
          for (let textTemplate of _this.textTemplateList) {
            if (_this.textTemplateDisplayInfo.displayOrder < textTemplate.displayOrder) {
              textTemplate.displayOrder--;
            }
          }
          _this.initialisationTemplate();
          _this.changeControlActive();
        }
      });
    },
    // 既定に設定・既定を解除ボタン押下時の処理
    setDefaultDisplayTemplate(isSet) {
      for (let textTemplate of this.textTemplateList) {
        if (this.displayOrder == textTemplate.displayOrder) {
          // 表示テンプレートの既定フラグを設定
          textTemplate.defaultFlag = isSet;
        } else {
          // 選択中でない表示テンプレートの既定フラグを削除
          textTemplate.defaultFlag = false;
        }
      }
    },
    // 選択中のテンプレートを上のテンプレートと入れ替え
    upTextTemplate() {
      if (this.displayOrder != 1) {
        this.shiftListDetail(true);
      }
    },
    // 選択中のテンプレートを下のテンプレートと入れ替え
    downTextTemplate() {
      if (this.displayOrder != this.textTemplateList.at(-1).displayOrder) {
        this.shiftListDetail(false);
      }
    },
    // テンプレート入れ替え処理
    shiftListDetail(isUp) {
      // 選択行を基準とし渡したリスト内で上下を入れ替え
      let result = shiftListDetail(this.textTemplateList, this.textTemplateDisplayInfo.displayOrder, isUp, this.textTemplateDisplayInfo);
      this.textTemplateList = result.targetList;
      this.textTemplateDisplayInfo = result.selectedRow;
      this.displayOrder = result.selectedRow.displayOrder;
    },
    // 置換項目挿入処理
    insertTextTemplateBody(selectedItemName) {
      // 選択中のテンプレート本文に選択した表示項目を追加
      this.textTemplateDisplayInfo.text = this.textTemplateDisplayInfo.text + "$" + selectedItemName + "$"
    },
    // 保存ボタン処理
    saveTextTemplate() {
      if (!this.textTemplateDisplayInfo.templateName) {
        // テンプレート名が空欄の場合
        this.showMessage("テンプレート名を入力してください。");
        return;
      } else {
        // テンプレート名が空欄でない場合
        for(let textTemplate of this.textTemplateList) {
          if (this.textTemplateDisplayInfo.templateName == textTemplate.templateName 
              && this.textTemplateDisplayInfo.displayOrder != textTemplate.displayOrder) {
            // 同一テンプレート名メッセージ
            this.showMessage("このテンプレート名は既に登録されています。");
            return;
          }
        }
        // テンプレート名が最大入力文字数超過の場合
        if (this.textTemplateDisplayInfo.templateName.length > 30) {
          // 最大文字数超過メッセージ
          this.showMessage("テンプレート名が最大文字数を超えるため登録できません。");
          return;
        }
        // 本文が最大入力文字数超過の場合
        if (this.textTemplateDisplayInfo.text.length > 2000) {
          // 最大文字数超過メッセージ
          this.showMessage("本文が最大文字数を超えるため登録できません。");
          return;
        }
        // テンプレート名に重複がない場合
        if (this.textTemplateList.length < this.textTemplateDisplayInfo.displayOrder) {
          // リストの件数より保存対象の表示順が大きい場合、新規またはコピー
          if (this.templateLimitCount == this.textTemplateList.length) {
            // 登録件数上限メッセージ
            this.showMessage("これ以上テンプレートを登録できません。");
            return;
          }
          if (this.textTemplateList.length == 0) {
            // 既定に設定する
            this.textTemplateDisplayInfo.defaultFlag = true;
          } else {
            // 既定に設定しない
            this.textTemplateDisplayInfo.defaultFlag = false;
          }
          this.textTemplateList.push(this.textTemplateDisplayInfo);
        } else {
           // 上書き保存の場合
          for (let textTemplate of this.textTemplateList) {
            if (this.textTemplateDisplayInfo.displayOrder == textTemplate.displayOrder) {
              // 上書き対象のプロパティを更新
              textTemplate = this.textTemplateDisplayInfo;
              for (let prop in textTemplate) {
                this.selectedTemplateInfo[prop] = textTemplate[prop];
              }
            }
          }
        }
      }
      this.initialisationTemplate();
    },
    // テンプレート情報初期値
    initialisationTemplate() {
      this.textTemplateDisplayInfo = {
        id: "",
        templateName: "",
        text: "",
        defaultFlag: false,
        displayOrder: null
      };
      this.displayOrder = null;
      this.isButtonDisabled = true;
      this.isTextAreaDisabled = true;
    }
  },
  data() {
    return {
      // 置換用転記テンプレート表示リスト
      textTemplateList: [],
      // 置換用表示項目リスト
      itemNameList: [],
      // 転記テンプレート登録上限数
      templateLimitCount: null,
      // 画面用テンプレート情報
      textTemplateDisplayInfo: {},
      // 選択中の置換用転記テンプレート
      selectedTemplateInfo: {},
      // 選択させた転記テンプレート表示順
      displayOrder: null,
      // 置換用表示項目
      itemName: "",
      // テンプレートが未選択または（新規）が選択中またはコピー中は非活性にする
      isButtonDisabled: true,
      // テンプレートが未選択なら非活性にする
      isTextAreaDisabled: true,
      // 既定に設定を表示
      //isDefault: true,
      // 転記テンプレート削除リスト
      textTemplateDeleteList: [],
      // 新規押下時の仮の表示順
      newDisplayOrder: 0,
    }
  },
  filters: {},
  components: {},
  created() {},
  mounted() {
    this.initialisationTemplate();
    this.changeControlActive();
  }
};
</script>
<style lang="scss" scoped>
.template-select-area {
  display: grid;
  grid-template-columns: 1.7fr 0.3fr;
  margin-right: 11px;
}
.template-edit-area {
  padding: 0 10px 10px 10px;
  margin-top: 16px;
  border: 1px solid #767676;
}
.buttonArea {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 16px;
}
.is-primary {
  width: 120px;
  height: 25px;
}
.arrow-button {
  width: 50px;
  height: 25px;
}
select.template-select-box option:checked {
  background: linear-gradient(#061e57, #061e57);
  color: #ffffff;
}
.body-text-area {
  display: block;
  resize: none;
  width: 100%;
  height: 305px;
  font-size: 16px;
  margin-bottom: 0px;
}
.right {
  position: absolute;
  right: 0;
}
.templatename-block, .displayitem-block {
  display: grid;
  grid-template-columns: 1fr 136px;
  padding-top: 10px;
  height: 36px;
}
.content-block {
  display: flex;
  padding-top: 8px;
  height: 38px;
  position: relative;
}
.left-area {
  display: flex;
}
.right-area {
  padding-left: 16px;
  text-align: right;
}
.templatename-label, .displayitem-label, .content-label {
  width: 150px;
  text-align: left;
  font-size: 16px;
  font-weight: bold;
  color: #061e57;
}
.templatename-input, .displayitem-select {
  flex: 1;
}
.maxlength {
  position: absolute;
  right: 140px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/patientdashboard/TranscriptionTemplateSetting.vue